import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function CadEvento() {
  const { DateTime } = require("luxon");

  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodevento, setedtcodevento] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtdtlancamento, setedtdtlancamento] = useState("");
  const [edtdtinicio, setedtdtinicio] = useState("");
  const [edtdttermino, setedtdttermino] = useState("");
  const [edtmultiplicador, setedtmultiplicador] = useState(0);

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext(); 

  const handleOpen = (cad) => {
    setedtcodevento(cad.codevento);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarEvento() {
    api
      .get("v1/cadastro/evento", {
        params: {
          busca: abusca,
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarEvento();
    },
    [showform, abusca, selectedCompany]
  );

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/evento",
        {
          descricao: edtdescricao,
          dtlancamento: edtdtlancamento,
          dtinicio: edtdtinicio,
          dttermino: edtdttermino,
          mutiplicador: edtmultiplicador,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarEvento();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/evento",
        {
          codevento: edtcodevento,
          descricao: edtdescricao,
          dtinicio: edtdtinicio,
          dttermino: edtdttermino,
          mutiplicador: edtmultiplicador,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarEvento();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/evento", {
        params: {
          codevento: edtcodevento,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarEvento();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodevento(0);
    setedtdescricao("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    setedtdtlancamento(dtcadastro);
    setedtdtinicio("");
    setedtdttermino("");
    setedtmultiplicador(0);
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcodevento(cad.codevento);
    setedtdescricao(cad.descricao);

    const dt = DateTime.fromISO(cad.dtlancamento)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd HH:mm");

    setedtdtlancamento(dt);

    const dt1 = DateTime.fromISO(cad.dtinicio)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd HH:mm");

    setedtdtinicio(dt1);

    const dt2 = DateTime.fromISO(cad.dttermino)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd HH:mm");

    setedtdttermino(dt2);
    setedtmultiplicador(cad.mutiplicador);
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Novo Cadastro</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricao}
                          onChange={(e) => setedtdescricao(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-3">
                        <label htmlFor="dtlancamento" className="form-label">
                          Dt. Lançamento
                        </label>
                        <input
                          type="datetime-local"
                          id="dtlancamento"
                          className="form-control"
                          placeholder="Dt. Lançamento"
                          value={edtdtlancamento}
                          disabled
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="dtinicio" className="form-label">
                          Dt. Início
                        </label>
                        <input
                          type="datetime-local"
                          id="dtinicio"
                          className="form-control"
                          placeholder="Dt. Início"
                          value={edtdtinicio}
                          onChange={(e) => setedtdtinicio(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="dttermino" className="form-label">
                          Dt. Término
                        </label>
                        <input
                          type="datetime-local"
                          id="dttermino"
                          className="form-control"
                          placeholder="Dt. Término"
                          value={edtdttermino}
                          onChange={(e) => setedtdttermino(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="multiplicador" className="form-label">
                          Multiplicador
                        </label>
                        <input
                          type="number"
                          id="multiplicador"
                          className="form-control"
                          placeholder="Multiplicador"
                          value={edtmultiplicador}
                          onChange={(e) => setedtmultiplicador(e.target.valueAsNumber)}
                        />
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModal}>
                      Cancelar
                    </button>
                    <button className="btn btn-success ms-4" onClick={Salvar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>

          <div className="row">
            <h1 className="ms-4">Cadastro de Eventos</h1>
            <p className="ms-4">Rotina para cadastrar os eventos que a empresa participa</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-10">
              <label className="d-block" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código ou descrição"
                name="busca"
                id="busca"
                className="form-control me-3"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th>Dt. Lançamento</th>
                  <th>Dt. Início</th>
                  <th>Dt. Término</th>
                  <th>Multiplicador</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(function (item) {
                  return (
                    <tr key={item.codevento}>
                      <th>{item.codevento}</th>
                      <th>{item.descricao}</th>
                      <th>{FormataDataHora(item.dtlancamento)}</th>
                      <th>{FormataDataHora(item.dtinicio)}</th>
                      <th>{FormataDataHora(item.dttermino)}</th>
                      <th>{item.mutiplicador}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-regular fa-pen-to-square"
                            onClick={() => openModalEditar(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-trash"
                            onClick={() => handleOpen(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={7}>Quantidade de Registros: {lista.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadEvento;
